import { RootState } from "../../../../../store";
import { ForecastOption } from "../../../../../../services/cloudchipr.api";
import { billingExplorerSetupPropertyByKeySelector } from "../../../setups/billing-explorer/billingExplorerSetupPropertyByKeySelector";

export const billingExplorerWidgetSetupForecastedOptionSelector = (
  state: RootState,
): ForecastOption | undefined => {
  return billingExplorerSetupPropertyByKeySelector("forecastOption")(state);
};
